import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useCreateShift = () => {

    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage, messages } = useContext(MessageContext);
    
    /** list contracts
    * @returns {array} - array of shifts */ 
    const createShift = async (body) => {
        try {

            messages.map(msg => removeMessage(msg.id));

            const msgId = addMessage({ type: "saving", header: t('general.moment'), body: t('info.savingShift')});
            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);

            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;
            result = await Axios.post(rootPath + "/api/v1/shifts", body, options);

            removeMessage(msgId);

            if (result && result.status === 201 && result.data) {
                addMessage({type: "success", header: t('general.saved'), body: t('info.shiftSaved')});
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.savingShiftFailed') });
            window.scrollTo(0, 0)
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.savingShiftFailed') });
            window.scrollTo(0, 0)
            if(error && error.response){
                return error.response;
            }
            return error;
        }
    }

    return { createShift };

}

export default useCreateShift;
